<template>
  <div>
    <NavBar
      class="new_navbar"
      left-text=""
      right-text="按钮"
      @click-right="onClickRight"
    >
      <template #right>
        <div :class="[class_name?'mobile-inner-header-icon-out':'mobile-inner-header-icon-click']" class="mobile-inner-header-icon "><span /><span /></div>
      </template>
    </NavBar>
    <div v-show="!class_name" class="mobile-inner-nav">
      <a href="#" @click="Setrouter('')">首页</a>
      <a href="#" @click="Setrouter('news')">新闻动态</a>
      <a href="#" @click="Setrouter('courtnotice')">开庭公告</a>
      <a href="#" @click="Setrouter('notice')">公告送达</a>
      <a href="#" @click="Setrouter('rules')">诉讼规程</a>
      <a href="#" @click="Setrouter('downloadapp')">庭审App下载</a>

    </div>
  </div>
</template>

<script>

// @ is an alias to /src
import { Toast, NavBar, Image as VanImage, Col, Row, Tag, Cell, CellGroup } from 'vant'
import { fetchList, getaxios, getaxiosdata, deleteaxios, PostData, PostPut, updateArticle } from '@/api/article'

export default {
  name: 'Home',
  components: {
    NavBar

  },
  data() {
    return {
      htmlname: '',
      class_name: true
    }
  },
  created() {
    this.htmlname = this.$store.state.user.web_name
  },

  methods: {
    Setrouter(url, data) {
      this.$router.push({ path: `/${url}` })
      this.onClickRight()
    },
    onClickLeft() {
      Toast('返回')
    },
    onClickRight() {
      this.class_name = !this.class_name
    }
  }
}
</script>
<style  lang="less" scoped>
        .slide-fade-enter-active {
                transition: all .3s ease;
        }
        .slide-fade-leave-active {
                transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
        }
        .slide-fade-enter, .slide-fade-leave-to
                /* .slide-fade-leave-active for below version 2.1.8 */ {
                transform: translateY(10px);
                opacity: 0;
        }
        .mobile-inner-nav a{
                -webkit-animation-duration: 0.5s;
                animation-duration: 0.5s;
                -webkit-animation-fill-mode: both;
                animation-fill-mode: both;
                -webkit-animation-name: returnToNormal;
                animation-name: returnToNormal;
        }

        @-webkit-keyframes returnToNormal {
                0% {
                        opacity: 0;
                        -webkit-transform: translate3d(0, -100%, 0);
                        transform: translate3d(0, -100%, 0);
                }

                100% {
                        opacity: 1;
                        -webkit-transform: none;
                        transform: none;
                }
        }

        @keyframes returnToNormal {
                0% {
                        opacity: 0;
                        -webkit-transform: translate3d(0, -100%, 0);
                        transform: translate3d(0, -100%, 0);
                }

                100% {
                        opacity: 1;
                        -webkit-transform: none;
                        transform: none;
                }
        }

    .van-tab__pane{
        width: auto;
        margin: 20px;
        background-color: #fff;
        border-radius: 12px;
        flex-shrink: 0;
        box-sizing: border-box;
    }
    .convey_box{

        background:rgba(245,245,245,1);
    }
    .pdf_box_bg{
        height: 100%;
    }
    .van-doc-demo-block__card{
        margin: 0 12px 0;
        overflow: hidden;
        border-radius: 8px;
    }
    .banner_box{
        position: relative;
        .banner_title_box{
            margin-left: 28px;
            margin-top: 40px;
            position: absolute;
            z-index: 10;
            color: #fff;
            .banner_title{
                font-size: 16px;
                margin-bottom: 16px;
            }
            .case_status{
                margin: 0;
                font-size: 22px;
            }
        }
    }

</style>
